/* tslint:disable */
/* eslint-disable */
/**
 * MONEI API v1
 * The MONEI API is organized around REST principles. Our API is designed to be intuitive and developer-friendly.  ### Base URL  All API requests should be made to:  ``` https://api.monei.com/v1 ```  ### Environment  MONEI provides two environments:  - **Test Environment**: For development and testing without processing real payments - **Live Environment**: For processing real transactions in production  ### Client Libraries  We provide official SDKs to simplify integration:  - [PHP SDK](https://github.com/MONEI/monei-php-sdk) - [Python SDK](https://github.com/MONEI/monei-python-sdk) - [Node.js SDK](https://github.com/MONEI/monei-node-sdk) - [Postman Collection](https://postman.monei.com/)  Our SDKs handle authentication, error handling, and request formatting automatically.  You can download the OpenAPI specification from the https://js.monei.com/api/v1/openapi.json and generate your own client library using the [OpenAPI Generator](https://openapi-generator.tech/).  ### Important Requirements  - All API requests must be made over HTTPS - If you are not using our official SDKs, you **must provide a valid `User-Agent` header** with each request - Requests without proper authentication will return a `401 Unauthorized` error  ### Error Handling  The API returns consistent error codes and messages to help you troubleshoot issues. Each response includes a `statusCode` attribute indicating the outcome of your request.  ### Rate Limits  The API implements rate limiting to ensure stability. If you exceed the limits, requests will return a `429 Too Many Requests` status code.
 *
 * The version of the OpenAPI document: 1.8.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface SendSubscriptionLinkRequest
 */
export interface SendSubscriptionLinkRequest {
  /**
   * Customer email to send the subscription link to
   * @type {string}
   * @memberof SendSubscriptionLinkRequest
   */
  customerEmail?: string;
  /**
   * Customer phone number to send the subscription link to
   * @type {string}
   * @memberof SendSubscriptionLinkRequest
   */
  customerPhone?: string;
  /**
   * Channel to use for sending the subscription link
   * @type {string}
   * @memberof SendSubscriptionLinkRequest
   */
  channel?: SendSubscriptionLinkRequestChannelEnum;
  /**
   * Language to use for the subscription link message
   * @type {string}
   * @memberof SendSubscriptionLinkRequest
   */
  language?: string;
}

export const SendSubscriptionLinkRequestChannelEnum = {
  EMAIL: 'EMAIL',
  WHATSAPP: 'WHATSAPP',
  SMS: 'SMS'
} as const;

export type SendSubscriptionLinkRequestChannelEnum =
  (typeof SendSubscriptionLinkRequestChannelEnum)[keyof typeof SendSubscriptionLinkRequestChannelEnum];
